import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
// import { useGetUserActivityQuery } from 'api/services/dataEndpoints';
import type { ExtUserActivityPlotType } from '../types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

interface IActivityPlotProps {
  userId: number | null;
  data: ExtUserActivityPlotType | null;
  filters: {
    dateRange: {
      from: string | null;
      to: string | null;
    };
  };
  isError: boolean;
  isLoading: boolean;
}

const ActivityPlot: React.FC<IActivityPlotProps> = ({
  userId, filters, data, isError, isLoading,
}) => {
  // const { data: apiData, isLoading, error } = useGetUserActivityQuery(
  //   { userId, ...filters },
  //   { skip: !userId },
  // );

  const chartData = {
    labels: data?.dailyActivity.map((item: { day: unknown }) => `${item.day}`) || [],
    datasets: [
      {
        label: 'Volleys per day',
        data: data?.dailyActivity?.map((item: { volleys: unknown }) => item.volleys) || [],
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'User Activity Volleys',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Enrollment Day',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Volleys/day',
        },
        beginAtZero: true,
      },
    },
  };

  if (isLoading) {
    return (
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography>Loading...</Typography>
      </Paper>
    );
  }

  if (isError) {
    return (
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography color="error">Cannot load user activity</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        User Activity
      </Typography>
      <Box sx={{ height: 400 }}>
        <Line data={chartData} options={options} />
      </Box>
    </Paper>
  );
};

export default ActivityPlot;
